import React, { useEffect, useState, useRef } from "react";
import Loader from "../Loader/Loader";
import { message, Button, Avatar } from "antd";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  getFilterAllCategories,
  editPromiseVoucher,
} from "../../Web Apis/Apis";
import Avtar from "../../Images/avatar.png";
import Select from "react-select";
import JsonToImage from "../JsonToImage";
import PreviewJsonFormat from "./PreviewJsonFormat";

function EditVoucher({
  showEditVoucherModal,
  setShowEditVoucherModal,
  action,
  setAction,
  selectedRow,
}) {
  const [open, setOpen] = useState(showEditVoucherModal);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(selectedRow.image || null);
  const [filterCategories, setFilterCategories] = useState({});
  const [filterMainCategory, setFilterMainCategory] = useState([]);
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [showFormatModal, setShowFormatModal] = useState(false);


  console.log("Edit data", selectedRow)
  const fileInputRef = useRef(null);
  const closeCreateModal = () => {
    setOpen(false);
    setShowEditVoucherModal(false);
  };

  const getAllFilterCategory = async () => {
    try {
      setLoading(true);

      const response = await getFilterAllCategories();

      if (response?.data?.success) {
        console.log("filter category", response?.data?.data)
        const modifiedObject = response?.data?.data?.reduce((acc, item) => {
          acc[item.id] = item.subcategory; // Assign category id as key and subcategories as value
          return acc;
        }, {});
        console.log("filter cat", modifiedObject)
        setFilterMainCategory(response?.data?.data);
        setFilterCategories(modifiedObject);
      }
    } catch (error) {
      console.log("Error while fetch filtered category", error.message);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllFilterCategory();
  }, []);

   const formatJson = {
  "id": 1744606153986,
  "title": "Sample Layout",
  "editableFields": {
    "background": {
      "type": "color",
      "value": "#FFFDD0",
      "editable": true
    },
    "image_0": {
      "type": "image",
      "filePath": "https://fetch-delivery.s3.amazonaws.com/kaza-house-swap/1746771458006-Image.png",
      "position": {
        "x": "55%",
        "y": "20%"
      },
      "size": {
        "width": "100px",
        "height": "100px"
      },
      "scale": 1.0351834945646925,
      "rotation": 0,
      "offset": {
        "x": 0,
        "y": 0
      },
      "editable": true
    },
    "image_1": {
      "type": "image",
      "filePath": "https://fetch-delivery.s3.amazonaws.com/kaza-house-swap/1746771458006-Image.png",
      "position": {
        "x": "15%",
        "y": "20%"
      },
      "size": {
        "width": "100px",
        "height": "100px"
      },
      "scale": 1.0731454474202733,
      "rotation": 0,
      "offset": {
        "x": 0,
        "y": 0
      },
      "editable": true
    },
    "text_0": {
      "type": "text",
      "text": "Title",
      "textAlign" : "center",
      "font": "Hammersmith One",
      "fontSize": "28px",
      "size": {
        "width": "100%",
        "height": "auto"
      },
      "color": "#4a0d26",
      "position": {
        "x": "0%",
        "y": "5%"
      },
      "scale": 1,
      "rotation": 0,
      "isBold": false,
      "isItalic": false,
      "isUnderline": false,
      "editable": true
    },
    "text_1": {
      "type": "text",
      "text": "Promise",
      "textAlign" : "center",
      "font": "Agbalumo",
      "fontSize": "20px",
      "size": {
        "width": "100%",
        "height": "auto"
      },
      "color": "#4a0d26",
      "position": {
        "x": "0%",
        "y": "75%"
      },
      "scale": 1,
      "rotation": 0,
      "isBold": false,
      "isItalic": false,
      "isUnderline": false,
      "editable": true
    }
  }
  }

  
  const handlePreviewFormat = () => {
    setShowFormatModal(true);
  };

  const formik = useFormik({
    initialValues: {
      title: selectedRow?.title || "",
      description: selectedRow?.description || "",
      coin: selectedRow?.coin || "",
      occasions: selectedRow?.occasions || [],
      relationships: selectedRow?.relationships || [],
      genders: selectedRow?.genders || [],
      ageGroups: selectedRow?.ageGroups || [],
      hobbies: selectedRow?.hobbies || [],

      personalityTypes: selectedRow?.personalityTypes || [],
      locations: selectedRow?.locations || [],
      personalization: selectedRow?.personalization || "",
      deliveryTimeFrame: selectedRow?.deliveryTimeFrame || "",
      emotionalImpacts: selectedRow?.emotionalImpacts || [],
      lifeStages: selectedRow?.lifeStages || [],
      voucherType: selectedRow?.voucherType || "",
      templateJson: JSON.stringify(selectedRow?.templateJson, null, 2) || "",
      image: selectedRow?.image || null,
    },
    validationSchema: Yup.object({
      templateJson: Yup.string().required(
        "Json for voucher layout is required"
      ),
      //     title: Yup.string().required("title name is required")
      //         .max(100, "title name should not be more than 100 characters")
      //         .min(3, "title name should be atleast 3 characters long")
      //         .trim("title name should not have spaces"),
      //     description: Yup.string().required("Description is required").trim("Description name should not have spaces")
      //         .max(500, "Description name should not be more than 500 characters")
      //         .min(10, "Description name should be atleast 10 characters long"),
      //     coin: Yup.string().required("Coin is required").matches(/^[0-9]+$/, "Only numbers are allowed"),
      //     occasions: Yup.string().required("Occassion is required"),
      //     relationships: Yup.string().required("Relationship is required"),
      //     genders: Yup.string().required("Gender is required"),
      //     ageGroups: Yup.string().required("Age Group is required"),
      //     personalityTypes: Yup.string().required("Personality Type is required"),
      //     locations: Yup.string().required("Location is required"),
      //     personalization: Yup.string().required("Personalization is required"),
      //     deliveryTimeFrame: Yup.string().required("Delivery time frame is required"),
      //     emotionalImpacts: Yup.string().required("Emotional impact is required"),
      //     lifeStages: Yup.string().required("Life stage is required"),
      //     // image: Yup.string().required("Image is required"),
      //     voucherType: Yup.string().required("Voucher type is required"),
      //     hobbies: Yup.string().required("Voucher type is required"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setLoading(true);

        const response = await editPromiseVoucher(selectedRow?.id, {
          ...values,
        });
        if (response?.data?.success) {
          message.success(response?.data?.message);
          resetForm();
          setOpen(false);
          setShowEditVoucherModal(false);
          setAction(!action);
        }
      } catch (error) {
        console.log("Error while creating admin", error.message);
        if (
                       error.message === "Network Error" ||
                       error.message.includes("ERR_INTERNET_DISCONNECTED")
                     ) {
                       // Handle internet disconnection
                       return;
                     }
                     // Handle specific error cases
                     if (error?.response?.status === 401) {
                       window.alert(
                         "Your account is logged in to another device, please login again !"
                       );
                       localStorage.clear();
                       window.location.href = "/login";
                     }
                     if (error?.response?.status === 500) {
                       message.error("Server not responding");
                     } else {
                      message.error(error?.response?.data?.message || "Error while updating vocher")
                     }
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  const handleImageChange = (file) => {
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      formik.setFieldValue("image", file);
    }
  };

  // const handleRemoveImage = () => {
  //     setImage(null);
  //     formik.setFieldValue("image", null);
  //     if (fileInputRef.current) {
  //         fileInputRef.current.value = null;
  //     }
  // };

  const emotionalOptions =
    filterCategories?.[14]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const occassions =
    filterCategories?.[2]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const age =
    filterCategories?.[7]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const gender =
    filterCategories?.[3]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const hobbiesData =
    filterCategories?.[8]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const lifeStage =
    filterCategories?.[12]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const personality =
    filterCategories?.[9]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const relation =
    filterCategories?.[4]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const personalizationship =
    filterCategories?.[11]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const locationData =
    filterCategories?.[10]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const vType =
    filterCategories?.[15]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const deliveryTime =
    filterCategories?.[13]?.map((sub) => ({
      value: sub.subcategory,
      label: sub.subcategory,
    })) || [];

  const handleJsonModal = () => {
    if (formik.values.templateJson === "" || !formik.values.templateJson) {
      message.error("Please provide valid json format");
      return;
    }

    try {
      const parsedJson = JSON.parse(formik.values.templateJson);
      if (
        !parsedJson ||
        typeof parsedJson !== "object" ||
        !parsedJson.editableFields
      ) {
        message.error("Invalid JSON structure. 'editableFields' missing.");
        return;
      }
      setShowJsonModal(true);
    } catch (error) {
      message.error("Invalid JSON format");
      return;
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[700px] flex flex-col">
        <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
          Edit Voucher Details
        </h3>

        <div className="flex-1 overflow-y-auto">
          <form onSubmit={formik.handleSubmit} className="p-8">
            <div className="flex gap-2 ">
              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">Title</label>

                <input
                  type="text"
                  name="title"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                  placeholder="Enter title of the voucher"
                />
                {formik.touched.title && formik.errors.title && (
                  <p className="text-red-600 ml-2">{formik.errors.title}</p>
                )}
              </div>

              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">Coins</label>
                <input
                  type="text"
                  name="coin"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.coin}
                  placeholder="Enter coins"
                />
                {formik.touched.coin && formik.errors.coin && (
                  <p className="text-red-600 ml-2">{formik.errors.coin}</p>
                )}
              </div>
            </div>

            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">
                {filterMainCategory?.find((cat) => cat.id === 2)?.category}
              </label>

              <Select
                isMulti
                name="occasions"
                options={occassions}
                className="w-full"
                classNamePrefix="select"
                onChange={(selectedOptions) => {
                  // Set the Formik value to an array of selected `value`s
                  formik.setFieldValue(
                    "occasions",
                    selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : []
                  );
                }}
                onBlur={() => formik.setFieldTouched("occasions", true)}
                value={occassions.filter((opt) =>
                  formik.values.occasions?.includes(opt.value)
                )}
                placeholder="Select options"
              />

              {formik.errors.occasions && (
                <p className="text-red-600 ml-2">{formik.errors.occasions}</p>
              )}
            </div>

            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">
                {filterMainCategory?.find((cat) => cat.id === 7)?.category}
              </label>

              <Select
                isMulti
                name="ageGroups"
                options={age}
                className="w-full"
                classNamePrefix="select"
                onChange={(selectedOptions) => {
                  // Set the Formik value to an array of selected `value`s
                  formik.setFieldValue(
                    "ageGroups",
                    selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : []
                  );
                }}
                onBlur={() => formik.setFieldTouched("ageGroups", true)}
                value={age.filter((opt) =>
                  formik.values.ageGroups?.includes(opt.value)
                )}
                placeholder="Select options"
              />

              {formik.errors.ageGroups && (
                <p className="text-red-600 ml-2">{formik.errors.ageGroups}</p>
              )}
            </div>

            <div className="flex gap-2 ">
              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 3)?.category}
                </label>

                <Select
                  isMulti
                  name="genders"
                  options={gender}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "genders",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("genders", true)}
                  value={gender.filter((opt) =>
                    formik.values.genders?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />
                {formik.errors.genders && (
                  <p className="text-red-600 ml-2">{formik.errors.genders}</p>
                )}
              </div>

              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 12)?.category}
                </label>

                <Select
                  isMulti
                  name="lifeStage"
                  options={lifeStage}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "lifeStages",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("lifeStages", true)}
                  value={lifeStage.filter((opt) =>
                    formik.values.lifeStages?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />

                {formik.errors.lifeStages && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.lifeStages}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">
                {filterMainCategory?.find((cat) => cat.id === 14)?.category}
              </label>

              <Select
                isMulti
                name="emotionalImpacts"
                options={emotionalOptions}
                className="w-full"
                classNamePrefix="select"
                onChange={(selectedOptions) => {
                  // Set the Formik value to an array of selected `value`s
                  formik.setFieldValue(
                    "emotionalImpacts",
                    selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : []
                  );
                }}
                onBlur={() => formik.setFieldTouched("emotionalImpacts", true)}
                value={emotionalOptions.filter((opt) =>
                  formik.values.emotionalImpacts?.includes(opt.value)
                )}
                placeholder="Select options"
              />

              {formik.errors.emotionalImpacts && (
                <p className="text-red-600 ml-2">
                  {formik.errors.emotionalImpacts}
                </p>
              )}
            </div>

            <div className="flex gap-2 ">
              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 8)?.category}
                </label>
                <Select
                  isMulti
                  name="hobbies"
                  options={hobbiesData}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "hobbies",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("hobbies", true)}
                  value={hobbiesData.filter((opt) =>
                    formik.values.hobbies?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />

                {formik.errors.hobbies && (
                  <p className="text-red-600 ml-2">{formik.errors.hobbies}</p>
                )}
              </div>

              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 9)?.category}
                </label>
                <Select
                  isMulti
                  name="personalityTypes"
                  options={personality}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "personalityTypes",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() =>
                    formik.setFieldTouched("personalityTypes", true)
                  }
                  value={personality.filter((opt) =>
                    formik.values.personalityTypes?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />

                {formik.errors.personalityTypes && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.personalityTypes}
                  </p>
                )}
              </div>
            </div>

            <div className="flex gap-2 ">
              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 4)?.category}
                </label>
                <Select
                  isMulti
                  name="relationships"
                  options={relation}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "relationships",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("relationships", true)}
                  value={relation.filter((opt) =>
                    formik.values.relationships?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />
                {formik.errors.relationships && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.relationships}
                  </p>
                )}
              </div>

              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 11)?.category}
                </label>
                <Select
                  isMulti
                  name="personalization"
                  options={personalizationship}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "personalization",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("personalization", true)}
                  value={personalizationship.filter((opt) =>
                    formik.values.personalization?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />
                {formik.errors.personalization && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.personalization}
                  </p>
                )}
              </div>
            </div>
            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">
                {filterMainCategory?.find((cat) => cat.id === 10)?.category}
              </label>

              <Select
                isMulti
                name="locations"
                options={locationData}
                className="w-full"
                classNamePrefix="select"
                onChange={(selectedOptions) => {
                  // Set the Formik value to an array of selected `value`s
                  formik.setFieldValue(
                    "locations",
                    selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : []
                  );
                }}
                onBlur={() => formik.setFieldTouched("locations", true)}
                value={locationData.filter((opt) =>
                  formik.values.locations?.includes(opt.value)
                )}
                placeholder="Select options"
              />

              {formik.errors.locations && (
                <p className="text-red-600 ml-2">{formik.errors.locations}</p>
              )}
            </div>

            <div className="flex gap-2 ">
              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 15)?.category}
                </label>

                <Select
                  isMulti
                  name="voucherType"
                  options={vType}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "voucherType",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("voucherType", true)}
                  value={vType.filter((opt) =>
                    formik.values.voucherType?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />

                {formik.errors.voucherType && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.voucherType}
                  </p>
                )}
              </div>

              <div className="w-full mt-2">
                <label className="block mb-1 font-bold">
                  {filterMainCategory?.find((cat) => cat.id === 13)?.category}
                </label>

                <Select
                  isMulti
                  name="deliveryTimeFrame"
                  options={deliveryTime}
                  className="w-full"
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    // Set the Formik value to an array of selected `value`s
                    formik.setFieldValue(
                      "deliveryTimeFrame",
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    );
                  }}
                  onBlur={() =>
                    formik.setFieldTouched("deliveryTimeFrame", true)
                  }
                  value={deliveryTime.filter((opt) =>
                    formik.values.deliveryTimeFrame?.includes(opt.value)
                  )}
                  placeholder="Select options"
                />

                {formik.errors.deliveryTimeFrame && (
                  <p className="text-red-600 ml-2">
                    {formik.errors.deliveryTimeFrame}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">Description</label>
              <textarea
                name="description"
                rows={2}
                className="border border-gray-800 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                placeholder="Enter description"
              />
              {formik.touched.description && formik.errors.description && (
                <p className="text-red-600 ml-2">{formik.errors.description}</p>
              )}
            </div>

            <div className="w-full mt-2">
              <label className="block mb-1 font-bold">Image Json</label>
              <textarea
                name="templateJson"
                rows={8}
                className="border border-gray-800 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.templateJson}
                placeholder="Enter Json format"
              />
              {formik.errors.templateJson && (
                <p className="text-red-600 mb-2">
                  {formik.errors.templateJson}
                </p>
              )}
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleJsonModal}
                type="button"
                className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
              >
                Preview Layout
              </button>
              <button
                onClick={handlePreviewFormat}
                type="button"
                className="bg-orange-300 text-black w-52 py-2 px-4 rounded-md hover:bg-orange-400 transition duration-200"
              >
                Preview Json Format
              </button>
            </div>

            <div className="w-full">
              <label className="block mb-1 text-lg font-semibold mt-2">
                Voucher Image:
              </label>
              {/* <div className="flex items-center gap-2 border border-gray-800 p-2 rounded-md">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    className="cursor-pointer text-lg"
                                />
                            </div>
                            {formik.touched.image && formik.errors.image && (
                                <p className="text-red-600">{formik.errors.image}</p>
                            )} */}

              <div className="mt-2 relative w-52 h-48">
                <img
                  src={image || Avtar}
                  alt="Profile Preview"
                  ref={fileInputRef}
                  className="border border-gray-800 w-full h-full object-cover"
                />
              </div>
            </div>
            {loading && <Loader />}
          </form>
        </div>

        <div className="flex justify-end p-4 border-t gap-6">
          <button
            onClick={closeCreateModal}
            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Cancel
          </button>
          <button
            onClick={formik?.handleSubmit}
            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
          >
            {formik.isSubmitting ? "Updating..." : "Update"}
          </button>
        </div>
      </div>

      {showJsonModal && (
        <JsonToImage
          json={JSON.parse(formik.values.templateJson)}
          setShowModal={setShowJsonModal}
          handleImageChange={(file) => handleImageChange(file)}
        />
      )}

      {showFormatModal && (
        <PreviewJsonFormat
          formatJson={JSON.stringify(formatJson, null, 2)}
          setShowModal={setShowFormatModal}
        />
      )}
    </div>
  );
}

export default EditVoucher;
